export enum InventoryStatus {
  AVAILABLE = 'AVAILABLE',
  TO_BE_CONFIRMED = 'TO_BE_CONFIRMED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}
